import React from "react";
import { Grid, Skeleton } from "@mui/material";

function TransactionSmallCard({ count }) {
  return (
    <Grid
      container
      className="Grid-padding"
      direction="row"
      justifyContent="flex-start"
      sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
    >
      {Array.from(new Array(count)).map((_, index) => (
        <Grid item key={index}>
          <div style={{ minWidth: 375, maxWidth: "417px", height: 90, borderRadius: "5px" }}>
            <Skeleton variant="rectangular" height={90} borderRadius={"5px"} />
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default TransactionSmallCard;
